import { useConfiguracionEstanciaQuery } from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"

export function useConfig() {
    const {hotel_id} = useProfile()
    const {data} = useConfiguracionEstanciaQuery({
        variables: {
            hotel_id
        }
    })

    const config = data?.configuracion_estancia?.data

    return {
        horas_extra: config?.horas_extra || false,
        noches_extras: config?.noches_extras || false,
        personas_extra: config?.personas_extra || false,
        checkin_anticipado: config?.checkin_anticipado || false,
        hora_checkin: config?.configuracion_noches?.hora_checkin || "",
        hora_checkout: config?.configuracion_noches?.hora_checkout || ""
    }
}